module.exports = __webpack_public_path__ + "static/media/LogoColor.7efb2ff3.svg";